import Axios from 'axios';
import React, { createContext, useContext } from 'react';
import { AuthContext } from './AuthContext';

export const ApiContext = createContext({});

const ApiProvider = ({ children }) => {
  const authContext = useContext(AuthContext);

  const apiClient = Axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: false,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
  });

  apiClient.interceptors.request.use((config) => {
    config.headers.post['Content-Type'] = 'application/json';
    if (authContext.authenticated && authContext.auth) {
      config.headers.common.Authorization = `Bearer ${authContext.auth.jwt}`;
    }
    return config;
  });

  const contextValue = { axios: apiClient };

  return (
    <ApiContext.Provider value={contextValue}>{children}</ApiContext.Provider>
  );
};

export default ApiProvider;
